import React from "react";
import { getRouteFormLink } from "components/common/LinkRenderer/LinkRendererLinks";
import Link from "next/link";

export interface LinkRendererProps {
    label: string;
    linkKey: string;
}

const LinkRenderer = ({ label, linkKey }: LinkRendererProps) => {
    const route = getRouteFormLink(linkKey);
    if (route) {
        return (
            <Link
                className="cursor-pointer text-irBlue-600 dark:text-darkPrimary-100 font-semibold"
                href={route}
                key={linkKey}
            >
                {label}
            </Link>
        );
    }

    return <span>{label}</span>;
};

export default LinkRenderer;
